import { ComponentAPI } from '@philips-internal/oswald-ui-core';
import { CountryFlagProperties } from './country-flag-types.js';
class CountryFlagAPI extends ComponentAPI {
    /**
     * Gets the country code.
     */
    getCode() {
        return this.state.code ?? CountryFlagProperties.code.defaultValue;
    }
    /**
     * Sets the country code.
     *
     * @param code - The new code.
     */
    setCode(code) {
        this.setState({ code });
    }
    /**
     * Gets if the order of the country flag and name are reversed.
     */
    isReverse() {
        return Boolean(this.state.reverse);
    }
    /**
     * Sets if the order of the country flag and name should be reversed.
     *
     * @param reverse - If the country flag and name should be reversed.
     */
    setReverse(reverse) {
        this.setState({ reverse });
    }
    /**
     * Gets if the country name is being shown.
     */
    isShowName() {
        return Boolean(this.state.showName);
    }
    /**
     * Sets if the country name should be shown.
     *
     * @param showName - If the name should be shown.
     */
    setShowName(showName) {
        this.setState({ showName });
    }
}
export { CountryFlagAPI, };
//# sourceMappingURL=country-flag-api.js.map